class PurchaseEmailTemplateCell extends UITableViewCell
{
    
}